export default __webpack_public_path__ + "assets/images/80390c28bfd26fb5a9998d3e8f6a6341.svg";